// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__AaHBa","crumb":"Breadcrumb_crumb__DqHlj","current":"Breadcrumb_current__1sIYY"};